export var identity=function identity(x){return x;};